import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { AuthProvider, useMeQuery } from "./lib/auth";
import { AppShell } from "./components/AppShell";
import { Login } from "./routes/Login";
import { Today } from "./routes/Today";
import { Week } from "./routes/Week";
import { Review } from "./routes/Review";
import { Habits } from "./routes/Habits";
import { HabitEditor } from "./routes/HabitEditor";
import { Settings } from "./routes/Settings";
import { Goals } from "./routes/Goals";
import { GoalNew } from "./routes/GoalNew";
import { GoalDetail } from "./routes/GoalDetail";
import { Onboarding } from "./routes/Onboarding";
import { Assistant } from "./routes/Assistant";
import { TaskEditor } from "./routes/TaskEditor";

export function App() {
  const me = useMeQuery();

  if (me.isPending) return <div className="splash" aria-busy="true" />;
  if (me.isError) {
    return (
      <div className="splash">
        <p>No pudimos conectar con el servidor.</p>
        <button className="btn" onClick={() => void me.refetch()}>Reintentar</button>
      </div>
    );
  }

  return (
    <BrowserRouter>
      {me.data && !me.data.onboarded ? (
        <AuthProvider user={me.data}>
          <main className="content">
            <Onboarding mode="first" />
          </main>
        </AuthProvider>
      ) : me.data ? (
        <AuthProvider user={me.data}>
          <Routes>
            <Route element={<AppShell />}>
              <Route index element={<Today />} />
              <Route path="semana" element={<Week />} />
              <Route path="revision" element={<Review />} />
              <Route path="habitos" element={<Habits />} />
              <Route path="habitos/nuevo" element={<HabitEditor />} />
              <Route path="habitos/:id" element={<HabitEditor />} />
              <Route path="tareas/nueva" element={<TaskEditor />} />
              <Route path="tareas/:id" element={<TaskEditor />} />
              <Route path="asistente" element={<Assistant />} />
              <Route path="perfil" element={<Onboarding mode="edit" />} />
              <Route path="metas" element={<Goals />} />
              <Route path="metas/nueva" element={<GoalNew />} />
              <Route path="metas/:id" element={<GoalDetail />} />
              <Route path="ajustes" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      ) : (
        <Routes>
          <Route path="*" element={<Login />} />
        </Routes>
      )}
    </BrowserRouter>
  );
}
